import { useEffect, useState } from "react";
import { Button, CircularProgress, InputLabel, MenuItem, Select } from "@mui/material";
import { useMutation, useQuery, useQueryClient } from 'react-query'
import FlexibleWidthDialog from "components/Dialog/FlexibleWidthDialog"
import { copy } from "../services/api";
import { useTranslation } from "react-i18next";
import { getCategoriesByMenu } from "routes/Builder/Categories/services/api";
import { getSubcategoriesByCategory } from "routes/Builder/Subcategories/services/api";

export default function Copy({ open, close, menu, subcategory, instance, reportAction }) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false)
  const [optionsCategories, setOptionsCategories] = useState(null)
  const [optionsSubcategories, setOptionsSubcategories] = useState(null)
  const [selectInstanceCategory, setSelectInstanceCategory] = useState(null)
  const [selectInstanceSubcategory, setSelectInstanceSubcategory] = useState(null)
  const queryClient = useQueryClient()
  const { data: dataCategories } = useQuery(
    ['categoriesByMenu', menu], () => getCategoriesByMenu(menu),
    { refetchOnWindowFocus: false, enabled: menu !== null && menu !== undefined }
  )
  const { data: dataSubcategories } = useQuery(
    ['subcategoriesByCategory', selectInstanceCategory, menu], () => getSubcategoriesByCategory(selectInstanceCategory, menu),
    { refetchOnWindowFocus: false, enabled: selectInstanceCategory !== null && selectInstanceCategory !== undefined }
  )

  useEffect(() => {
    if (open) queryClient.invalidateQueries('categoriesByMenu') // eslint-disable-next-line
  }, [open])

  useEffect(() => {
    if (dataCategories !== null && dataCategories !== undefined) {
      let options = []
      dataCategories.data.forEach(cat => {
        options.push({ _id: cat._id, name: cat.name })
      });
      setOptionsCategories(options)
    } // eslint-disable-next-line
  }, [dataCategories])

  useEffect(() => {
    if (dataSubcategories !== null && dataSubcategories !== undefined) {
      let options = []
      dataSubcategories.data.forEach(subcat => {
        options.push({ _id: subcat._id, name: subcat.name })
      });
      setOptionsSubcategories(options)
    } // eslint-disable-next-line
  }, [dataSubcategories])

  const mutation = useMutation(copy, {
    onSuccess: (dataCategories) => {
      setIsLoading(false)
      if (dataCategories.status === "error") {
        reportAction(false, 'Error al guardar los datos', 'error')
      } else { reportAction(true, 'Acción realizada correctamente', 'success') }
    }
  })

  const handleCopy = () => {
    setIsLoading(true)
    mutation.mutate({ id: instance._id, params: { subcategory: selectInstanceSubcategory } })
  }

  const handleClose = () => {
    setOptionsSubcategories(null)
    setSelectInstanceCategory(null)
    setSelectInstanceSubcategory(null)
    close()
  }

  const handleChangeCategory = (event) => {
    setSelectInstanceSubcategory(null)
    setSelectInstanceCategory(event.target.value)
  }
  const handleChangeSubcategory = (event) => setSelectInstanceSubcategory(event.target.value)

  const Actions = () => (<>
    {!isLoading ? <>
      <Button onClick={handleClose}>{t('button_text_cancel')}</Button>
      <Button variant="contained" color="info" disabled={selectInstanceCategory === null || selectInstanceSubcategory === null} onClick={() => handleCopy()}>{t('button_text_copy')}</Button>
    </> : <CircularProgress />}
  </>)

  return (<>
    <FlexibleWidthDialog open={open} title={t('builder_products_dialog_title_copy')} actions={<Actions />}>
      <>
        {(dataCategories !== null && optionsCategories !== null) ?
          <div style={{ marginBottom: 12 }}>
            <InputLabel htmlFor="grouped-select-categories" required style={{ fontSize: 14 }}>Categorias</InputLabel>
            <Select fullWidth size="small" margin="dense" id="grouped-select-categories" onChange={handleChangeCategory}>
              <MenuItem value={null}> <em>{t('builder_page_menu_select_label')}</em> </MenuItem>
              {optionsCategories.map((opt, j) => (
                <MenuItem key={`${opt._id}-${j}`} role="option" value={opt._id}> {opt.name} </MenuItem>
              ))}
            </Select>
          </div> : null}
        {(dataSubcategories !== null && optionsSubcategories !== null) ?
          <div>
            <InputLabel htmlFor="grouped-select-subcategories" required style={{ fontSize: 14 }}>Subcategorias</InputLabel>
            <Select fullWidth size="small" margin="dense" id="grouped-select-subcategories" onChange={handleChangeSubcategory}>
              <MenuItem value={null}> <em>{t('builder_page_menu_select_label')}</em> </MenuItem>
              {optionsSubcategories.map((opt, j) => (
                <MenuItem key={`${opt._id}-${j}`} role="option" value={opt._id}> {opt.name} </MenuItem>
              ))}
            </Select>
          </div> : null}
      </>
    </FlexibleWidthDialog>
  </>)
}